module.exports = __webpack_public_path__ + "img/curling-stone.ea6c7a2a.svg";